import React from "react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  FormLabel,
  Stack,
  Box,
  useDisclosure,
  Switch,
  Text,
  useColorMode,
} from "@chakra-ui/react";

export const InstructionOptions = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();
  const color = { light: "black", dark: "white" };
  const darkThemeEnabled = colorMode !== "light";
  const btnRef = React.useRef();

  const printBtnClickHandler = () => {
    // First close the drawer, so it doesn't impact the browser print.
    onClose();

    // Call the print instruction function in a timeout
    // so the drawer has a chance to fully close.
    setTimeout(() => props.onPrintInstructions(), 300);
  };

  const clearProgressBtnClickHandler = () => {
    // First close the drawer.
    onClose();

    props.onClearProgress();
  };

  const progressBarSizeChangeHandler = (value) => {
    props.onProgressBarSizeChange(value);
  };

  return (
    <>
      <Button
        colorScheme="blue"
        className="no-print"
        pos="fixed"
        bottom="0"
        right={4}
        zIndex="1000"
        mb={4}
        tabIndex="1"
        onClick={onOpen}
      >
        Options
      </Button>

      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader color={color[colorMode]}>Options</DrawerHeader>

          <DrawerBody>
            <Stack spacing="16px">
              <Box>
                <Button
                  w="100%"
                  colorScheme="blue"
                  onClick={() => printBtnClickHandler()}
                >
                  Print
                </Button>
              </Box>
              <Box>
                <Button
                  w="100%"
                  colorScheme="red"
                  onClick={() => clearProgressBtnClickHandler()}
                >
                  Clear Progress
                </Button>
              </Box>
            </Stack>

            <Stack spacing="16px" mt={6}>
              <Text fontSize="xl" color={color[colorMode]}>
                Preferences
              </Text>
              <Box>
                <FormLabel
                  htmlFor="themeToggle"
                  width="218px"
                  color={color[colorMode]}
                >
                  Dark Theme
                </FormLabel>
                <Switch
                  id="themeToggle"
                  size="lg"
                  isChecked={darkThemeEnabled}
                  onChange={() => toggleColorMode()}
                />
              </Box>
              <Box align="left">
                <FormLabel
                  htmlFor="progressBarSize"
                  width="218px"
                  color={color[colorMode]}
                >
                  Big Progress Bar
                </FormLabel>
                <Switch
                  id="progressBarSize"
                  size="lg"
                  isChecked={props.progressBarSize === "lg"}
                  onChange={(e) =>
                    progressBarSizeChangeHandler(e.target.checked ? "lg" : "sm")
                  }
                />
              </Box>
              <Box align="left">
                <FormLabel
                  htmlFor="confettiOnCompleteSwitch"
                  width="218px"
                  color={color[colorMode]}
                >
                  Confetti on Completion
                </FormLabel>
                <Switch
                  id="confettiOnCompleteSwitch"
                  size="lg"
                  isChecked={props.confettiOnComplete}
                  onChange={(e) =>
                    props.onConfettiOnCompleteChange(e.target.checked)
                  }
                />
              </Box>
            </Stack>
          </DrawerBody>

          <DrawerFooter>
            <Button variant="outline" mr={3} onClick={onClose}>
              Close
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
